// extracted by mini-css-extract-plugin
export default {"root":"SegmentedControl_root__-pZ8V","item":"SegmentedControl_item__Q6V-d","last":"SegmentedControl_last__ujgM6","first":"SegmentedControl_first__AYS1J"};